import { Grid, Select, styled, Tooltip } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { BankAccountModel } from "../../../Api/Models/BankAccountModel";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";
import { BankAccountDto } from "../../../Types/Api/DTO/BankAccountDto";
import { ConditionalFieldDto } from "../../../Types/Api/DTO/ConditionalField";
import DetailChip from "../components/Chips/DetailChip";
import * as Yup from "yup";
import pxToRem from "../../../Asset/theme/functions/pxToRem";
import { GhabzDto, GhabzDtoGhabzFields, GhabzDtoGhabzRows } from "../../../Types/Api/DTO/GhabzDto";
import { FieldRange } from "../../../Types/Api/DTO/FieldRangeDto";
import { GhabzModel } from "../../../Api/Models/GhabzModel";
import { ErrorToaast } from "../../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
const validationSchema = Yup.object().shape({
  AvarezName: Yup.string().required("الزامی است"),
  Message: Yup.string().required("الزامی است"),
  Formula: Yup.string().required("الزامی است"),
  BankAccountId: Yup.string().required("الزامی است"),
});
const CustomDivider = styled("div")(({ theme }) => ({
  border: `1px grey solid`,
  background: "grey",
}));
export default function ForthStep(props: {
  disabled: boolean;
  status: boolean;
  handleBack: any;
  handleNext: any;
  setLoading: any;
  setFinalGhabz: any;
}) {
  let BankAccount = new BankAccountModel();
  let conditionsParams: ConditionalFieldDto[] = useSelector((state: any) => state.conditionsParams);
  let symboledParams: FieldRange[] = useSelector((state: any) => state.symboledParams);
  const ghabzModel = new GhabzModel();
  const [allConditions, setallConditions] = useState<ConditionalFieldDto[]>([]);
  const [allBank, setAllBank] = useState<BankAccountDto[]>([]);
  const submitFormRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    props.setLoading(true);
    BankAccount.getAll()
      .then((r) => {
        props.setLoading(false);
        setAllBank(r.data.data);
      })
      .catch((r) => {
        props.setLoading(false);
        ErrorToaast("خطا در برقراری ارتباط");
      });
    var allConditonss = conditionsParams.filter((a, i) => conditionsParams.findIndex((s) => a.Symbole === s.Symbole) === i);
    setallConditions(allConditonss);
    return () => {
      setallConditions([]);
    };
  }, []);
  const formik = useFormik({
    initialValues: {
      AvarezName: "",
      Message: "",
      Formula: "",
      BankAccountId: "",
    },
    onSubmit: async (r) => {
      await props.setLoading(true);
      let ghabzFields: GhabzDtoGhabzFields[] = symboledParams.map((r) => {
        return { FieldId: r.Field.id.toString(), Symbole: r.Symbole };
      });

      let ghabzRows: GhabzDtoGhabzRows[] = conditionsParams.map((r) => {
        return {
          ParamAmount: r.ParamAmount.toString(),
          ParamEqual: r.ParamEqual === "" ? null : r.ParamEqual,
          ParamMax: r.ParamMax === "" ? null : r.ParamMax,
          ParamMin: r.ParamMin === "" ? null : r.ParamMin,
          ParamName: r.ParamName.toString(),
          GhabzRowsKindEnum: r.GhabzRowsKindEnum,
        };
      });
      let sendGhabz: GhabzDto = {
        AvarezName: r.AvarezName,
        Message: r.Message,
        Formula: r.Formula,
        BankAccountId: r.BankAccountId,
        GhabzFields: ghabzFields,
        GhabzRows: ghabzRows,
      };
      console.log(sendGhabz);

      await ghabzModel
        .crete(sendGhabz)
        .then((r) => {
          props.setFinalGhabz(r.data.data);
          props.setLoading(false);
        })
        .then((r) => {
          props.setLoading(false);
        });
      await props.handleNext();
    },
    validationSchema: validationSchema,
  });
  const handleEnd = () => {
    submitFormRef?.current?.click();
  };
  return (
    <MDBox px={2}>
      <MDBox>
        <MDBox bgColor={"#f0f2f5"} borderRadius={5} p={"10px 5px"} mb={5}>
          <MDTypography fontSize={14}>
            پارامتر هایی که منتخب هستند و دارای شرط میباشند در لیست زیر مشخص شده است از نماد آن ها در فرمول استفاده کنید .
          </MDTypography>
        </MDBox>
        <MDBox bgColor={"ghostwhite"} py={1} px={1} my={2} borderRadius={5}>
          {allConditions
            .sort((a, b) => (a.Symbole === b.Symbole ? 0 : a.Symbole > b.Symbole ? -1 : 1))
            .map((r) => {
              return <DetailChip label={r.Field.name} symbole={r.Symbole} key={uuid()} />;
            })}
        </MDBox>
        <Grid item container flexDirection={"column"}>
          <Grid item sx={{ width: "100%" }}>
            <MDBox py={1}>
              <Grid container justifyContent={"space-between"} alignItems={"center"}>
                <Grid item>
                  <MDTypography fontSize={14}>شرط های موجود</MDTypography>
                </Grid>
              </Grid>
            </MDBox>
            <CustomDivider />
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <Grid container py={2} spacing={3}>
                <Grid container item xs={12} md={6} lg={6} alignItems="center">
                  <Grid item xs={12} md={3} lg={3}>
                    <MDTypography fontWeight="regular" fontSize={14}>
                      عنوان قالب عوارض
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={3} lg={9}>
                    <MDInput
                      fullWidth
                      label="عنوان"
                      name="AvarezName"
                      onChange={formik.handleChange}
                      error={formik.touched.AvarezName && Boolean(formik.errors.AvarezName)}
                      helperText={formik.touched.AvarezName && formik.errors.AvarezName}
                      value={formik.values.AvarezName}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={6} lg={6} alignItems="center">
                  <Grid item xs={12} md={3} lg={3}>
                    <MDTypography fontWeight="regular" fontSize={14}>
                      پیام عوارض
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={3} lg={9}>
                    <MDInput
                      fullWidth
                      label="پیام"
                      name="Message"
                      multiline
                      onChange={formik.handleChange}
                      error={formik.touched.Message && Boolean(formik.errors.Message)}
                      helperText={formik.touched.Message && formik.errors.Message}
                      value={formik.values.Message}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={6} lg={6} alignItems="center">
                  <Grid item xs={12} md={3} lg={3}>
                    <MDTypography fontWeight="regular" fontSize={14}>
                      فرمول عوارض
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={3} lg={9}>
                    <Tooltip
                      title={
                        <MDTypography color="white" fontSize={13}>
                          در این قسمت فرمول را با توجه به پارامتر های شرط گذاری شده بنویسید
                          <br />
                          مانند: a+b * c ^1/2
                        </MDTypography>
                      }
                    >
                      <MDInput
                        fullWidth
                        label="فرمول"
                        name="Formula"
                        onChange={formik.handleChange}
                        error={formik.touched.Formula && Boolean(formik.errors.Formula)}
                        helperText={formik.touched.Formula && formik.errors.Formula}
                        value={formik.values.Formula}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid container item xs={12} md={6} lg={6} alignItems="center">
                  <Grid item xs={12} md={3} lg={3}>
                    <MDTypography fontWeight="regular" fontSize={14}>
                      انتخاب بانک
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={3} lg={9}>
                    <Select
                      name={"BankAccountId"}
                      native
                      fullWidth
                      defaultValue={""}
                      id="grouped-native-select"
                      error={formik.touched.BankAccountId && Boolean(formik.errors.BankAccountId)}
                      onChange={(e: any) => {
                        formik.setFieldValue("BankAccountId", e.target.value);
                        // handleKindChange(e.target.value);
                      }}
                    >
                      <option value="" disabled style={{ background: "#e0e0e0" }}>
                        انتخاب کنید
                      </option>
                      {allBank.map((e: any) => {
                        return (
                          <option key={uuid()} value={e.id?.toString() ?? ""}>
                            {e.bankName}
                          </option>
                        );
                      })}
                    </Select>
                    {formik.touched.BankAccountId && formik.errors.BankAccountId && (
                      <MDTypography color={"error"} fontSize={pxToRem(12)} sx={{ margin: "0 12px" }}>
                        {formik.errors.BankAccountId}
                      </MDTypography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <button type="submit" ref={submitFormRef} hidden></button>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox sx={{ display: "flex", flexDirection: "row", py: 2 }}>
        <MDButton color="primary" variant={"outlined"} disabled={props.disabled} onClick={props.handleBack} sx={{ mr: 1 }}>
          مرحله قبل
        </MDButton>
        <MDBox sx={{ flex: "1 1 auto" }} />

        <MDButton onClick={handleEnd} variant={"outlined"} color="info">
          {props.status ? "اتمام" : "مرحله بعد"}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
